import restClient from 'api/restClient';
import { AxiosInstance } from 'axios';
import { GraphsAvgData, Timezone } from 'backendTypes';

class GraphsService {
  constructor(public readonly httpRequest: AxiosInstance) {}

  private getWeightsUrl(segment: string, eligibilityId?: string): string {
    return eligibilityId
      ? `/api/graphs/weights/${segment}/${eligibilityId}/`
      : `/api/graphs/weights/${segment}/`;
  }

  async getGraphsWeeklyData(eligibilityId?: string): Promise<GraphsAvgData[]> {
    const { data } = await restClient(this.getWeightsUrl('daily-average', eligibilityId), {
      method: 'GET',
    });
    return data;
  }

  async getGraphsMonthlyData(eligibilityId?: string): Promise<GraphsAvgData[]> {
    const { data } = await restClient(this.getWeightsUrl('daily-average', eligibilityId), {
      method: 'GET',
      params: {
        days: 30,
      },
    });
    return data;
  }

  async getGraphsSixMonthsData(eligibilityId?: string): Promise<GraphsAvgData[]> {
    const { data } = await restClient(this.getWeightsUrl('weekly-average', eligibilityId), {
      method: 'GET',
      params: {
        weeks: 24,
      },
    });
    return data;
  }

  async getGraphsLastYearData(eligibilityId?: string): Promise<GraphsAvgData[]> {
    const { data } = await restClient(this.getWeightsUrl('monthly-average', eligibilityId), {
      method: 'GET',
    });
    return data;
  }

  async getTimezone(): Promise<Timezone> {
    const { data } = await restClient('/api/profile/timezone/', {
      method: 'GET',
    });
    return data;
  }

  async setTimezone(timezone: string): Promise<Timezone> {
    const { data } = await restClient('/api/profile/timezone/', {
      method: 'PATCH',
      data: { timezone },
    });
    return data;
  }
}

export { GraphsService };
